export const canCopyToClipboard = navigator?.clipboard || false;
